define.alias("shared/components/shared/ui/dynamic-social-set", "preview-grid/components/shared/ui/dynamic-social-set");